// Autogenerated by Kyd Editor. File->Generate Boilerplate
// DO NOT EDIT.

import uk.co.nickthecoder.kyd.KydTypeRegistry

fun registerTypes() {
    with(KydTypeRegistry) {

        // Management
        registerManagementType( "CavernQuest") { game -> CavernQuest(game) }
        // End Management

        // Director
        registerDirectorType( "MenuDirector") { MenuDirector() }
        registerDirectorType( "PlayDirector") { PlayDirector() }
        // End Director

        // Stage
        // End Stage

        // Behaviour
        registerBehaviourType( "BlastsCounter") { BlastsCounter() }
        registerBehaviourType( "Dynamite") { Dynamite() }
        registerBehaviourType( "Fuel") { Fuel() }
        registerBehaviourType( "FuelStatus") { FuelStatus() }
        registerBehaviourType( "Granite") { Granite() }
        registerBehaviourType( "Monster") { Monster() }
        registerBehaviourType( "Player") { Player() }
        registerBehaviourType( "Rock") { Rock() }
        registerBehaviourType( "Ship") { Ship() }
        registerBehaviourType( "Soil") { Soil() }
        registerBehaviourType( "SpawnPoint") { SpawnPoint() }
        // End Behaviour

    }
}
